// bootstrap3 and react tabs don't get along very well. I'm not even so convinced of using the stop event as a hack.
// However, I was inspired by this article: https://blog.logrocket.com/how-to-build-tab-component-react/

import React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

/* gettings subs */
import Votes from './votes';
import ApprovedAnswers from './approved_answers';
import Overview from './overview';
import AnsweredQuestions from './other_answers'
import CommentedQuestions from './comments'

// api
import { get_user_data_by_id } from 'commons/api';
import usePageTitle from 'commons/page_title';

export default function UserPanel()
{
    // const user_data = useContext(UserContext);
    // console.log('user data =>  ' + JSON.stringify(user_data));
    const [activeTab, setActiveTab] = useState("user-view-questions");
    const [user_name, set_user_name] = useState('');
    const pageTitle = user_name !== '' ? `${user_name} - Q&A Activity` : 'Q&A Activity';
    usePageTitle(pageTitle);
    let params = useParams();
    const userid = params.id;
    const tabs_list = [
        {
            id: 'user-view-questions',
            label: 'Questions',
            icon: 'ui-icon-help'
        },
        {
            id: 'user-view-votes',
            label: 'Votes cast',
            icon: 'fa-regular fa-thumbs-up'
        },
        // {
        //     id: 'user-view-followed',
        //     label: 'Following',
        //     icon: 'ui-icon-notifications-bell'
        // },
        {
            id: 'user-view-approved',
            label: 'Approved answers',
            icon: 'fa-solid fa-award'
        },
        {
            id: 'user-view-answers',
            label: 'Other answers',
            icon: 'fa-solid fa-reply'
        },
        {
            id: 'user-view-comments',
            label: 'Comments',
            icon: 'fa-solid fa-comment'
        }
    ];

    useEffect(() =>
    {
        if(params.id === '') return;
        let mounted = true;
        const fetchData = async () =>
        {
            const response =  await get_user_data_by_id(params.id);
            const data = await response.json();
            if (mounted)
            {
                if(data.status !== 'error') set_user_name(data.fullname);
            }
        }
        // call the function
        fetchData()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [params.id]);

    const TabContent = ({ id, activeTab, children }) =>
    {
        return (
            activeTab === id ? <div className="tab-pane active">
                {children}
            </div>
                : null
        );
    };

    const TabTitle = ({ id, label, icon, active }) =>
    {
        const base_class = 'nav-link';
        const handleClick = (evt) =>
        {
            evt.preventDefault();
            evt.stopPropagation();
            setActiveTab(id);
        };

        return (
            <li onClick={handleClick} className={active === id ? 'active ' + base_class : base_class}>
                <a className="nav-link" href={id}><i className={icon}></i> {label}</a>
            </li>
        )
    };

    // if (user_data === null) return <AjaxSpinner />
    return (
        <div id="user-view">

            <div id="subheader">
                <div id="subheader-header">
                    <h2>{user_name} - Q&A activity</h2>
                </div>
                <div id="subheader-body">
                    <p>This section provides an overview of the user activity within the Q&amp;A section.</p>
                </div>
            </div>

            <ul className="nav nav-tabs">
                {tabs_list.map(item =>
                (
                    <TabTitle key={item.id} id={item.id} label={item.label} icon={item.icon} active={activeTab} />
                ))}
            </ul>
            <div className="tab-content">
                <TabContent id="user-view-questions" activeTab={activeTab}>
                    <Overview username={userid} />
                </TabContent>
                <TabContent id="user-view-votes" activeTab={activeTab}>
                    <Votes username={userid} />
                </TabContent>
                {/* <TabContent id="user-view-followed" activeTab={activeTab}>
                    <FollowedQuestions username={userid} />
                </TabContent> */}
                <TabContent id="user-view-approved" activeTab={activeTab}>
                    <ApprovedAnswers username={userid} />
                </TabContent>
                <TabContent id="user-view-answers" activeTab={activeTab}>
                    <AnsweredQuestions username={userid} />
                </TabContent>
                <TabContent id="user-view-comments" activeTab={activeTab}>
                    <CommentedQuestions username={userid} />
                </TabContent>

            </div>
        </div>
    );
};
